import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    [
      face.m.any,
      face.u.pri,
      face.m.pri,
    ],
  ],
  name: 'Arrow',
};
